export default "https://cdn1.saucelabs.com/web-ui/images/assets/fe513285f947876551dab747b878fbc7.png";